module.exports = __webpack_public_path__ + "static/new-3-d432ef216b33231560e6677dd6c21d07.png";